import { useParams } from 'react-router-dom';

const useTokenIdParamUtil = () => {
  const params = useParams<{ tokenId: string }>();
  return params.tokenId ? parseInt(params.tokenId, 10) : undefined;
};

export default useTokenIdParamUtil;
